import React from 'react';
import styles from './LoadingState.module.css';

export function LoadingState() {
  return (
    <div className={styles.container} role="status" aria-live="polite" aria-label="Loading game challenge">
      {/* Screen reader announcement - using absolute position instead of sr-only for better compatibility */}
      <span style={{
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: 0,
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: 0,
      }}>Loading game challenge information...</span>
      
      {/* Header skeleton */}
      <div className={styles.header} aria-hidden="true">
        <div className={styles.iconSkeleton} />
        <div className={styles.titleGroup}>
          <div className={styles.titleSkeleton} />
          <div className={styles.taglineSkeleton} />
        </div>
      </div>
      
      {/* Stats skeleton */}
      <div className={styles.statsGrid} aria-hidden="true">
        <div className={styles.statItem}>
          <div className={styles.statValue} />
          <div className={styles.statLabel} />
        </div>
        <div className={styles.statItem}>
          <div className={styles.statValue} />
          <div className={styles.statLabel} />
        </div>
        <div className={styles.statItem}>
          <div className={styles.statValue} />
          <div className={styles.statLabel} />
        </div>
      </div>
      
      {/* Challenge info skeleton */}
      <div className={styles.challengeInfo} aria-hidden="true">
        <div className={styles.challengeLabel} />
        <div className={styles.challengeTitle} />
        <div className={styles.challengeSubtitle} />
      </div>
      
      {/* Button skeleton */}
      <div className={styles.buttonSkeleton} aria-hidden="true" />
    </div>
  );
}